<template>
    <label :class="{mobile:isMobile}">{{label}} <span v-if="required" class="span" style="color:red">*</span> </label>
</template>

<script>
    export default {
        name: "i-label",
        methods: {},
        props:{
            "label":{type:String,default:"label"},
            "required": {type:Boolean,default:false}
        },
        computed:{
            isMobile(){
                return this.m === "";
            }
        }
    }
</script>

<style scoped>
    label{
        color:#2b2b2b;
        font-size:14px;
        font-weight: bold;
        margin-bottom:6px;
        display:block;
        /*text-align: left;*/
    }
    label.mobile{
        font-size:18px;

    }

</style>